// rx-lens-option.js - Custom Rx Lens Option Injector
(function() {
  //console.log("Rx Lens Option Script Started");
  
  // Configuration options
  const config = {
    rxButtonText: "Rx", 
    rxPrice: "$XX.XX", // Update this with your price
    swatchGroupSelector: '[option-name="Lens Type"]',
    swatchListSelector: '.swatch-view',
    modalId: 'rx-redirect-modal'
  };

  // Initialize when DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Create the modal first
    createRedirectModal();
    // Then initialize the Rx option
    initRxOptionProcess();
  });
  
  document.addEventListener('page:load', initRxOptionProcess);
  document.addEventListener('shopify:section:load', initRxOptionProcess);

  // Create the modal dialog
  function createRedirectModal() {
    // Check if modal already exists
    if (document.getElementById(config.modalId)) return;
    
    // Create the modal container
    const modal = document.createElement('div');
    modal.id = config.modalId;
    modal.className = 'modal';
    modal.style.display = 'none';
    modal.style.position = 'fixed';
    modal.style.zIndex = '9999';
    modal.style.left = '0';
    modal.style.top = '0';
    modal.style.width = '100%';
    modal.style.height = '100%';
    modal.style.backgroundColor = 'rgba(0,0,0,0.5)';
    
    // Create the modal content
    const modalContent = document.createElement('div');
    modalContent.className = 'modal-content';
    modalContent.style.backgroundColor = '#fff';
    modalContent.style.margin = '15% auto';
    modalContent.style.padding = '20px';
    modalContent.style.border = '1px solid #888';
    modalContent.style.width = '80%';
    modalContent.style.maxWidth = '500px';
    modalContent.style.borderRadius = '15px';
    
    // Create the message paragraph
    const message = document.createElement('p');
    message.style.fontSize = '18px';
    message.innerHTML = 'You are being redirected to our CliC Rx site for prescription lenses. Different discounts, terms &amp; policies apply.';
    
    // Create the actions container
    const actions = document.createElement('div');
    actions.className = 'modal-actions';
    actions.style.marginTop = '20px';
    actions.style.textAlign = 'right';
    
    // Create the confirm button
    const confirmButton = document.createElement('button');
    confirmButton.id = 'confirm-rx-redirect';
    confirmButton.className = 'btn btn--secondary';
    confirmButton.style.marginLeft = '10px';
    confirmButton.textContent = 'Continue to CliC Rx';
    
    // Create the cancel button
    const cancelButton = document.createElement('button');
    cancelButton.id = 'cancel-rx-redirect';
    cancelButton.className = 'btn btn--secondary';
    cancelButton.style.marginLeft = '10px';
    cancelButton.textContent = 'Cancel';
    
    // Assemble the modal
    actions.appendChild(cancelButton);
    actions.appendChild(confirmButton);
    
    modalContent.appendChild(message);
    modalContent.appendChild(actions);
    modal.appendChild(modalContent);
    
    document.body.appendChild(modal);
    
    //console.log('Rx redirect modal created');
  }
  
  // Show the modal and set up the redirect
  function showRedirectModal(rxUrl) {
    const modal = document.getElementById(config.modalId);
    if (!modal) return;
    
    // Show the modal
    modal.style.display = 'block';
    
    // Set up event listeners
    const confirmButton = document.getElementById('confirm-rx-redirect');
    const cancelButton = document.getElementById('cancel-rx-redirect');
    
    // Remove any existing event listeners
    const newConfirmButton = confirmButton.cloneNode(true);
    const newCancelButton = cancelButton.cloneNode(true);
    
    confirmButton.parentNode.replaceChild(newConfirmButton, confirmButton);
    cancelButton.parentNode.replaceChild(newCancelButton, cancelButton);
    
    // Add new event listeners
    newConfirmButton.addEventListener('click', function() {
      modal.style.display = 'none';
      window.location.href = rxUrl;
    });
    
    newCancelButton.addEventListener('click', function() {
      modal.style.display = 'none';
    });
    
    // Also close when clicking outside the modal
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }

  function initRxOptionProcess() {
    //console.log("Initializing Rx option process");
    waitForSwatchKing(function() {
      const rxUrl = getRxUrl();
      //console.log("Rx URL found:", rxUrl);
      if (rxUrl) {
        addRxOption(rxUrl);
      } else {
        //console.log("No valid Rx URL found, not adding button");
      }
    });
  }

  function waitForSwatchKing(callback) {
    const checkInterval = 300;
    const maxChecks = 50;
    let checkCount = 0;
    
    const interval = setInterval(function() {
      const swatchGroup = document.querySelector(config.swatchGroupSelector);
      
      if (swatchGroup && swatchGroup.querySelector(config.swatchListSelector)) {
        clearInterval(interval);
        //console.log("Swatch King elements found");
        callback();
      } else if (checkCount >= maxChecks) {
        clearInterval(interval);
        //console.warn('Swatch King elements not detected after maximum checks');
      }
      
      checkCount++;
    }, checkInterval);
  }

  function getRxUrl() {
    // Check for metafield data in link format (object with url property)
    if (window.productMetafields && 
        window.productMetafields.rxUrl && 
        typeof window.productMetafields.rxUrl === 'object' &&
        window.productMetafields.rxUrl.url) {
      return window.productMetafields.rxUrl.url;
    }
    
    // Fall back to URL parameter for testing
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('debug_rx')) {
      return 'https://your-prescription-store.com/products/test-product';
    }
    
    return null;
  }

  function addRxOption(rxUrl) {
    const swatchGroup = document.querySelector(config.swatchGroupSelector);
    if (!swatchGroup) return;
    
    const swatchList = swatchGroup.querySelector(config.swatchListSelector);
    if (!swatchList) return;
    
    // Get the last item to modify its class and add our new item after it
    const lastItem = swatchList.querySelector('li:last-child');
    if (!lastItem) return;
    
    // Remove 'last-btn' class from the current last button
    const lastButton = lastItem.querySelector('.last-btn');
    if (lastButton) {
      lastButton.classList.remove('last-btn');
    }
    
    // Create the new Rx option element
    const rxOption = document.createElement('li');
    rxOption.className = 'swatch-view-item';
    rxOption.setAttribute('orig-value', config.rxButtonText);
    rxOption.setAttribute('aria-label', config.rxButtonText);
    rxOption.setAttribute('role', 'radio');
    rxOption.setAttribute('aria-checked', 'false');
    rxOption.setAttribute('tabindex', '0');
    
    // Create the HTML for the new option
    rxOption.innerHTML = `
      <div class="last-btn swatch-button swatch-group-selector star-set-btn" 
           swatch-option="${swatchGroup.getAttribute('option-target')}" 
           type="swatch-button" 
           data-value="${config.rxButtonText}" 
           orig-value="${config.rxButtonText}">
        <div swatch-inside="true" class="swatch-title-and-icon-container">
          <div class="swatch-button-title-text" swatch-inside="true">
            <span swatch-inside="true">${config.rxButtonText}</span>
          </div>
          <div swatch-inside="true" class="swatch-button-price-hidden">
            <span swatch-inside="true">${config.rxPrice}</span>
          </div>
        </div>
      </div>
    `;
    
    // Add click event listener for the Rx option - now shows modal instead of immediate redirect
    rxOption.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Show the modal instead of immediate redirect
      showRedirectModal(rxUrl);
      
      return false;
    }, true);
    
    // Append the Rx option to the swatch list
    swatchList.appendChild(rxOption);
    
    //console.log('Rx lens option successfully added with URL:', rxUrl);
  }
})();